import { combineReducers } from 'redux';
import transactions from '@blockcatio/tabby-library/lib/reducers/transactions';
import currencyExchangeRates from '@blockcatio/tabby-library/lib/reducers/currencyExchangeRates';

import account from './account';
import app from './app';
import campaigns from './campaigns';
import createCampaign from './createCampaign';
import redeemReward from './redeemReward';
import token from './token';

export default combineReducers({
  account,
  app,
  campaigns,
  createCampaign,
  currencyExchangeRates,
  redeemReward,
  transactions,
  token,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js